import { useEffect, useRef } from 'react';
import Loading from '../whitaijiFrontendLibrary/components/Loading';
import T from './Translation';

function extractMonoWaveform(audioBuffer, sampleRate = 1000) {
  const rawData = [];
  const numChannels = audioBuffer.numberOfChannels;
  const length = audioBuffer.length;
  const step = Math.floor(length / sampleRate);

  for (let i = 0; i < sampleRate; i++) {
    let sum = 0;
    for (let ch = 0; ch < numChannels; ch++) {
      const channelData = audioBuffer.getChannelData(ch);
      sum += channelData[i * step] || 0;
    }
    rawData.push(sum / numChannels);
  }

  return rawData;
}

async function decodeAudioBuffers(audioContext, tracks, sampleRate = 1000) {
  const bufferMap = new Map();

  await Promise.all(
    tracks.map(async (track) => {
      try {
        if (!track?.soundSource) {
          console.error(`Track ${track?._id} missing soundSource`);
          return;
        }


        const response = await fetch(track?.soundSource);
        const arrayBuffer = await response.arrayBuffer();
        const audioBuffer = await audioContext.decodeAudioData(arrayBuffer);
        const waveform = extractMonoWaveform(audioBuffer, sampleRate);

        let voAudioBuffer = null
        try {
          if (!track?.aiVoSource) {
            //console.error(`Track ${track?._id} missing aiVoSource`);
            
          } else {
            const voResponse = await fetch(track?.aiVoSource)
            const voArrayBuffer = await voResponse.arrayBuffer();
            voAudioBuffer = await audioContext.decodeAudioData(voArrayBuffer);
          }


        } catch (err) {
          console.error(`Failed to decode vo track ${track?._id}:`, err);
        }

/*         bufferMap.set({
          trackId: track._id, 
          audioBuffer,
          waveform: waveform,
        }
        ); */
        //console.log('bufferMap lwdmlwekdm', bufferMap);
        bufferMap.set(track._id, {buffer: audioBuffer, waveform, voBuffer: voAudioBuffer, lyrics: track?.lyrics});
      } catch (err) {
        console.error(`Failed to decode track ${track?._id}:`, err);
      }
    })
  );

  return bufferMap;
}

export default function AudioBufferLoader({ tracks, onReady, loading, setLoading }) {
  const audioBuffersRef = useRef(new Map());
  const audioContextRef = useRef(null);

  useEffect(() => {
    if (!tracks || tracks.length === 0) return;

    const loadBuffers = async () => {
      if (!audioContextRef.current) {
        audioContextRef.current = new (window.AudioContext || window.webkitAudioContext)();
      }

      setLoading(true);
      const buffers = await decodeAudioBuffers(audioContextRef.current, tracks);
      audioBuffersRef.current = buffers;
      setLoading(false);

      if (onReady) {
        onReady(buffers, audioContextRef.current);
      }
    };

    loadBuffers();
  }, [tracks]);

  return (
    <div>
      {loading && <Loading />}
      {/* {loading ? <Loading /> : <p><T obj={{en: "The concert is ready! 🎵", it: "Il Concerto è pronto! 🎵" }}/> </p>} */}
    </div>
  );
}
